import React from 'react';
import { Toaster } from 'react-hot-toast';

import MainContent from '../../components/mainContent/MainContent';
import { Outlet } from 'react-router-dom';
import { JustificarMinutaGrilla } from './components/JustificarMinutaGrilla';

export default function JustificarMinuta() {
  return (
    <>
      <MainContent
        titulo='Justificar Minuta'
        component={<JustificarMinutaGrilla />}
        tableMaxWidth
      />
      <Outlet />
    </>
  );
}